$(document).ready(function() {
    $('#menu-item-products').mouseover(function() {
        $('#submenu-products').slideDown('fast');
    });
    $('#menu-products').mouseleave(function() {
        $('#submenu-products').slideUp('fast');
    });
    $('#menu-item-goodtoknow').mouseover(function() {
        $('#submenu-goodtoknow').slideDown('fast');
    });
    $('#menu-goodtoknow').mouseleave(function() {
        $('#submenu-goodtoknow').slideUp('fast');
    });
    $('#menu-item-companyinfo').mouseover(function() {
        $('#submenu-companyinfo').slideDown('fast');
    });
    $('#menu-companyinfo').mouseleave(function() {
        $('#submenu-companyinfo').slideUp('fast');
    });
    $('#menu-item-customerservice').mouseover(function() {
        $('#submenu-customerservice').slideDown('fast');
    });
    $('#menu-customerservice').mouseleave(function() {
        $('#submenu-customerservice').slideUp('fast');
    });
    $('#menu-item-account').mouseover(function() {
        $('#submenu-account').slideDown('fast');
    });
    $('#menu-account').mouseleave(function() {
        $('#submenu-account').slideUp('fast');
    });
  
  
    $('#menutriggerhamburger').click(function() {
        $('#menumobile').slideToggle('fast');
    });
});